import React, { Component, PropTypes } from 'react'

import './App.scss'
import InitService from './components/InitService'
import ErrorModal from './components/ErrorModal'
import * as localStorage from 'utils/localStorage'

import amplitude from 'amplitude-js'
import { AmplitudeProvider } from '@amplitude/react-amplitude'

class App extends Component {
  componentDidMount () {
    this.loadPromoCode()
  }

  loadPromoCode () {
    const { promoCode } = this.props
    if (!promoCode) {
      return
    }

    const twentyFourHours = 24 * 60 * 60 * 1000
    const expiresAt = Date.now() + twentyFourHours

    localStorage.setItem('aliada_promoCode', promoCode, { expiresAt })
  }

  render () {
    const {
      children,
      error,
      location,
    } = this.props

    return (
      <div className='App'>
        <InitService location={location}/>
        <ErrorModal error={error} />

        <AmplitudeProvider
          amplitudeInstance={amplitude.getInstance()}
          apiKey={process.env.AMPLITUDE_API_KEY}
        >
          {children}
        </AmplitudeProvider>
      </div>
    )
  }
}
App.displayName = 'App'
App.propTypes = {
  promoCode: PropTypes.string
}
App.defaultProps = {}

export default App



// WEBPACK FOOTER //
// ./src/screens/App/App.js